<template lang="html">
  <el-form ref="form" v-form :model="form" addAction="lcwpReceiptRecord/addLcwpReceiptRecord.action" editAction="lcwpReceiptRecord/saveLcwpReceiptRecord.action" selectAction="lcwpReceiptRecord/selectLcwpReceiptRecord.action" :rules="rules" label-width="150px">
      <el-col :span="24">

          <el-form-item label="商家名称">
            <plush-business-select placeholder="可以根据商家名称、用户姓名、手机快速检索" @change="onBusinessChange"></plush-business-select>
          </el-form-item>

          <hr/>

          <el-row>
            <el-col :span="12">

                <h4 style="margin-left:80px;font-weight:bold;margin-top:10px;margin-bottom:30px;">商家信息</h4>

                <el-form-item label="用户" prop="customName">
                    <el-input  v-model="form.customName" placeholder="请输入用户名"></el-input>
                </el-form-item>

                <el-form-item label="联系电话" prop="customPhone">
                  <el-input  v-model="form.customPhone" placeholder="请输入联系电话"></el-input>
                </el-form-item>

                <el-form-item  label="公司名称" prop="companyName">
                  <el-input  v-model="form.companyName" placeholder="请输入公司名称"></el-input>
                </el-form-item>

                <el-form-item label="公司类型" prop="companyType">
                  <el-select  v-model="form.companyType" placeholder="请选择公司类型">
                    <el-option label="新车" value="新车"></el-option>
                    <el-option label="二手车" value="二手车"></el-option>
                    <el-option label="美容保养" value="美容保养"></el-option>
                    <el-option label="装饰配件" value="装饰配件"></el-option>
                    <el-option label="改装装潢" value="改装装潢"></el-option>
                    <el-option label="汽车维修" value="汽车维修"></el-option>
                    <el-option label="其他商户" value="其他商户"></el-option>
                  </el-select>
                </el-form-item>

                  <el-form-item label="收款人" prop="payeeName">
                      <employee-select placeholder="收款人" ref="employeeSelect" @onEmployeeSelected="onEmployeeSelected" v-model="form.payeeName"></employee-select>
                  </el-form-item>
            </el-col>
            <el-col :span="12">

              <h4 style="margin-left:80px;font-weight:bold;margin-top:10px;margin-bottom:30px;">
                付费信息（财务确认）
              </h4>
              <el-form-item label="上架时间" prop="openingTime">
                <el-date-picker
                  v-model="form.openingTime"
                  type="date"
                  placeholder="请输入上架时间">
                </el-date-picker>
              </el-form-item>

              <el-form-item label="付款周期" prop="paymentCycle">

                <el-select  v-model="form.paymentCycle" placeholder="请输入付款周期">
                  <el-option v-for="month in 12" :label="month+'个月'" :value="month"></el-option>
                </el-select>
              </el-form-item>

              <el-form-item  label="付款金额" prop="paymentMoney">
                <el-input  v-model="form.paymentMoney" type="number" placeholder="请输入付款金额"></el-input>
              </el-form-item>

              <el-form-item label="成本" prop="cost">
                <el-input  v-model="form.cost"  type="number" placeholder="请输入成本"></el-input>
              </el-form-item>

              <el-form-item label="税后收入">
                <el-input disabled :value="form.shuihou"  type="number"></el-input>
              </el-form-item>

            </el-col>
          </el-row>
      </el-col>

      <el-col>
          <el-form-item>
              <el-button type="primary">保存</el-button>
          </el-form-item>
      </el-col>

  </el-form>
</template>

<script>
import SearchAddressInput from '@/components/SearchAddressInput'
import BrandAndFactorySelect from '@/components/BrandAndFactorySelect'
import Config from '@/framework/configs/Config'
import channelSelect from '@/components/channelSelect'
import PlushBusinessSelect from '@/components/PlushBusinessSelect'
import BasicPager from '@/mixins/BasicPager'
import EmployeeSelect from '@/components/EmployeeSelect'
export default {
  extends: BasicPager,
  components: {
    SearchAddressInput,
    BrandAndFactorySelect,
    channelSelect,
    PlushBusinessSelect,
    EmployeeSelect
  },
  data: function () {
    // let priceValidator = (rule, value, callback) => {
    //   let match = value+"".match(/^\d+$/);
    //   if(!match){
    //     callback(new Error('只能为整数哦'));
    //   }else{
    //     callback();
    //   }
    // };

    return {
      baseUrl: Config.baseUrl,
      isAdmin: null,
      form: {
        customName: null,
        companyType: null,
        customId: null,
        payeeId: null,
        shuihou: 0
      },
      rules: {
        // customName: [{
        //     required: true,
        //     message: '用户名不能为空！'
        // }],
        // customPhone:[{
        //     required: true,
        //     message: '联系电话不能为空！'
        // }],
        companyName: [{
          required: true,
          message: '公司名称不能为空！'
        }],
        companyType: [{
          required: true,
          message: '公司类型不能为空！'
        }],
        payeeName: [{
          required: true,
          message: '收款人不能为空！'
        }],
        openingTime: [{
          required: true,
          trigger: 'change',
          message: '上架时间不能为空！'
        }],
        paymentCycle: [{
          required: true,
          trigger: 'change',
          message: '付款周期不能为空！'
        }],
        paymentMoney: [{
          required: true,
          message: '付款金额不能为空！'
        }
          // ,{
          //  validator: priceValidator, trigger: 'blur'
          // }
        ],
        cost: [{
          required: true,
          message: '成本不能为空'
        }
          // ,{
          //  validator: priceValidator, trigger: 'blur'
          // }
        ]
      }
    }
  },
  watch: {
    'form.paymentMoney': function (newValue) {
      this.form.shuihou = (newValue / 1.06).toFixed(2)
    }
  },
  created: function () {
    this.form.id = this.$route.params.id

    if (this.loginInfo.loginPath == 'channel') {
      this.form.channelId = this.loginInfo.id
    }

    let userInfo = JSON.parse(localStorage.userInfo)
    this.form.createPeople = this.loginInfo.realName
    this.isAdmin = userInfo.loginPath != 'channel'
  },
  methods: {
    onEmployeeSelected: function (item) {
      this.form.payeeId = item.id
      this.form.payeeName = item.text
    },
    onBusinessChange: function (item) {
      this.form.companyName = item.businessName
      this.form.customName = item.contacts
      this.form.companyType = item.type
      this.form.customPhone = item.phone
      this.form.customId = item.id
    },
    channelIdsChange: function (channelId) {
      if (channelId) {
        this.form.channelId = channelId
      } else {
        this.form.channelId = null
      }
    },
    onChanged: function (brands) {
      this.form.assignedToTheBrand = JSON.stringify(brands)
    },
    onChange: function (addressInfo) {
      // 查询省市区areaCode
      // this.form.address = addressInfo.value

      let city = addressInfo.province + ' ' + addressInfo.city + ' ' + addressInfo.county

      this.form.city = city
      this.center = addressInfo.location.split(',')
      this.form.location = addressInfo.location.split(',')

      this.form.detailAddress = addressInfo.value.replace(city + ' ', '')
      this.form.longitude = this.form.location[0]
      this.form.latitude = this.form.location[1]
    },
    onFilterParams: function (params) {
      if (params.type != '新车') {
        params.assignedToTheBrand = '[]'
      }
    },

    onSelectInfo: function (dataInfo) {
      this.$nextTick(function () {
        this.$refs['employeeSelect'].setValue(dataInfo.datas.payeeId)
      })
    }
  }
}
</script>
